/**
 * Field character limits for the application
 * These limits are applied consistently across all forms
 */

export const FIELD_LIMITS = {
  // Names and titles (single line inputs)
  NAME: 50,
  TITLE: 25,
  TRIP_TITLE: 50,
  SEGMENT_TITLE: 25,
  
  COST_DESCRIPTION: 50,
  
  // Descriptions and notes (multi-line textareas)
  DESCRIPTION: 500,
  NOTES: 500,
  SEGMENT_NOTES: 500,
  
  // URLs and links
  LINK: 200,
  URL: 200
};

// Helper to truncate text to limit
export const truncateToLimit = (text, limit) => {
  if (!text) return text;
  return text.slice(0, limit);
};

export default FIELD_LIMITS;
